import React from 'react';
import FormatUtility, { Formats } from '../Utility/FormatUtility';
import { ZdsDivider } from '@zig-design-system/ui-components-react';
export const PriceTable = ({ children }) => {
    return (React.createElement("table", { className: "price-table", style: { width: '100%' } },
        React.createElement("tbody", null, children)));
};
export const PriceTableRow = ({ label, amount, className }) => {
    return (React.createElement("tr", { className: className },
        React.createElement("td", { className: "zds-truncate zds-padding-y-2" }, label),
        React.createElement("td", { className: "zds-text-right zds-padding-y-2" }, FormatUtility.format(amount, Formats.currency))));
};
export const PriceTableDividerRow = () => (React.createElement("tr", null,
    React.createElement("td", { colSpan: 2, className: "zds-padding-y-1" },
        React.createElement(ZdsDivider, null))));
